import { ViewLevel } from '../Constants';
import ProgressBar from './ProgessBar';
import { Link } from "react-router-dom";

function KeyResult(props) {
    const percentComplete = 
    props.year in props.data.progress
    ? Math.floor(props.data.progress[props.year].percentComplete / props.data.progress[props.year].weight) || 0
    : 0

    const progressBarElement =
        props.year in props.data.progress && !props.data.doNotCount
        ? <ProgressBar percentComplete={percentComplete} shrinkForNextButton={true} />
        : <div className="progress-bar shrink-for-next-button progress-bar-value">n/a</div>

    const nextLink =
        /*props.viewLevel >= ViewLevel.Tasks
        ? <Link className="next" to={`/?y=${props.year}&o=${props.data.objectiveId}&k=${props.data.id}&v=${props.viewLevel}`}>❯</Link>
        :*/ null;

    return (
        <div className="dashboard-section key-result">
            <header>
                {props.data.name}
                <div className="subtitle">FY{props.data.year}</div>
            </header>
            <div className="description">{props.data.description}</div>
            {progressBarElement}
            { !props.doNotShowNotes && !props.data.doNotShowNotes && <div className="progress-notes">{props.data.progressNotes || ''}</div> }
            {nextLink}
        </div>
    );
}

export default KeyResult;
